import React from 'react'
import Svg, { ClipPath, Defs, G, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const EyeClosed = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${EyeClosed.dimensions.width} ${EyeClosed.dimensions.height}`}
      {...otherProps}
    >
      <G clipPath="url(#a)">
        <Path fill="#fff" d="M3 2h27v22H3z" />
        <Path
          d="M7.228 14.625a.5.5 0 0 0-.813-.583l.813.583Zm-3.634 3.348a.5.5 0 0 0 .812.583l-.812-.583Zm9.64.265a.5.5 0 0 0-.94-.338l.94.338Zm-2.351 3.593a.5.5 0 1 0 .941.338l-.941-.338Zm15.573-7.24-.3-.4-.8.6.3.4.8-.6Zm2.144 4.53a.5.5 0 1 0 .8-.599l-.8.6Zm-7.57-1.358-.175-.468-.936.35.175.469.936-.35Zm.535 4.281a.5.5 0 0 0 .936-.35l-.936.35ZM5.09 11.995a.5.5 0 0 0-.729.685l.729-.685Zm24.021.669a.5.5 0 1 0-.757-.653l.757.653ZM5.411 16.299l-.406-.291.406.291Zm6.883 1.601-1.411 3.931.941.338 1.41-3.93-.94-.339Zm13.362-2.71 2.944 3.932.8-.6-2.944-3.93-.8.599Zm-5.562 2.924 1.47 3.93.937-.35-1.47-3.93-.937.35ZM4.362 12.68c3.187 3.393 6.339 5.121 9.291 5.772 2.952.65 5.66.214 7.95-.646 2.284-.858 4.158-2.142 5.457-3.207.651-.532 1.16-1.013 1.51-1.361a14.816 14.816 0 0 0 .531-.562l.008-.008c0-.002.002-.002.002-.003.001-.001.001-.001-.378-.328a86.16 86.16 0 0 1-.378-.326h-.001l-.005.007a19.621 19.621 0 0 1-1.922 1.808c-1.246 1.02-3.025 2.236-5.177 3.044-2.148.807-4.657 1.205-7.382.605-2.722-.6-5.702-2.206-8.777-5.48l-.729.685Zm2.053 1.362-1.41 1.966.812.583 1.41-1.966-.812-.583Zm-1.41 1.966-1.411 1.965.812.583 1.41-1.965-.811-.584Z"
          fill={color || Color.premiumBlack}
        />
      </G>
      <Defs>
        <ClipPath id="a">
          <Path fill="#fff" transform="translate(3 4)" d="M0 0h27v22H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

EyeClosed.dimensions = {
  width: 33,
  height: 26,
}

export default EyeClosed
